import React from "react";

const NotFoundPage = () => {
    return (
        <div>
            <h3>404 Хуудас олдсонгүй!</h3>
        </div>
    )
};

export default NotFoundPage;